import { formData } from '@/utils';
const path = 'customer';
export default {
	// GET
	me: path + '/me',
	cityList: path + '/address-province/all',
	products: path + '/product',
	promotions: path + '/product/promotion',
	cates: path + '/category',
	productList: path + '/product/list',
	bookingList: path + '/booking/list',
	booking: path + '/booking', // add booking id
	messageList: path + '/notif/list',
	searchProduct: path + '/search/product',
	labList: `${path}/lab/list`,
	getNurseApply: `${path}/booking/{id}/check-rebooking`,
	blogList: path + '/blog/list',
	blogCategories: path + '/blog/categories',
	blog: path + '/blog', // + '/' + slug
	page: path + '/page', // + '/' + slug

	// POST
	register: path + '/register',
	login: path + '/auth',
	loginLink: path + '/login-link',
	resetPassword: path + '/reset-password',
	forgotPassword: path + '/forgot-password',
	sendOtpVerifyPhone: path + '/send-otp-verify-phone',
	verifyOtp: path + '/verify-otp',
	resendOtp: path + '/resend-otp',
	updateUser: path + '/me/update',
	addUserAddress: path + '/me/address',
	updateUserAddress: path + '/me/address/update',
	addBooking: path + '/booking',
	cancelBooking: path + '/booking/{id}/cancel',
	markAsReadAll: path + '/notif/mark-as-read-all',
	markAsRead: path + '/notif/{id}/mark-as-read',
	payService: path + '/payment',
	checkNurseAvailable: path + '/check-nurse-available',
	suggestNurse: path + '/suggest-time',
	checkRebooking: path + '/booking/{id}/check-rebooking',
	reFindNurse: path + '/booking/{id}/refind-nurse',
	reSendNurse: path + '/booking/{id}/resend-nurse',
	checkBookingChildSession: path + '/booking/child-booking/{id}',
	availableNurses: path + '/available-nurses',
	contact: path + '/contact',
	listApplyNurse: path + '/booking/{id}/nurses',
	payAgain: path + '/payment/pay-again',
	selectNurse: path + '/booking/{id}/select-nurse',
	bookingComplete: path + '/booking/{id}/confirm-completed',

	// PUT , PATCH
	// DELETE
	deleteAddress: path + '/me/address/delete',
};
